import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';

@Injectable()
export class LoggedOutGuard  {
  constructor(
    private router: Router,
    private auth: AuthService,
  ) {}
  canActivate(): Observable<boolean> {
    return new Observable((observer) => {
      this.auth.loggedIn.subscribe((isLoggedIn) => {
        !!isLoggedIn && this.router.navigate(['dashboard', 'admin']);

        observer.next(!isLoggedIn);
      });
    });
  }
}
